import { render, staticRenderFns } from "./InformacoesTarefaComponent.vue?vue&type=template&id=99278180"
import script from "./InformacoesTarefaComponent.vue?vue&type=script&lang=js"
export * from "./InformacoesTarefaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports